import { apiRequest } from "./apiClient";

const uniq = (items = []) => Array.from(new Set(items.filter(Boolean)));

export async function bagliHatirlaticilariSil({
  familyId,
  kaynak,
  kaynakId,
  reminderId = null,
  reminderIds = [],
}) {
  const ids = uniq([reminderId, ...reminderIds]);

  try {
    await apiRequest("/notifications/linked-reminders/delete", {
      method: "POST",
      body: JSON.stringify({
        familyId,
        kaynak,
        kaynakId,
        reminderId: ids[0] || null,
        reminderIds: ids,
      }),
    });
  } catch (err) {
    console.warn("[bagliHatirlaticilariSil] Hatırlatıcılar silinemedi:", err);
  }
}
